export default function Left() {
    return <div>Left</div>;
  }